const locale = {
	// #region Courses fields
	DETAILS_COURSES_FIELD_TITLE: 'Title',
	DETAILS_COURSES_FIELD_DATE_START: 'Start date',
	DETAILS_COURSES_FIELD_DATE_END: 'End date',
	DETAILS_COURSES_FIELD_SKILL: 'Skill',
	DETAILS_COURSES_FIELD_LENGTH_HOURS: 'Duration (hours)',
	DETAILS_COURSES_FIELD_TAGS: 'Tags',
	DETAILS_COURSES_FIELD_WARNING: 'Warning',
	DETAILS_COURSES_FIELD_BLOCKED: 'Blocked',
	// #endregion

	// #region Details Courses buttons
	DETAILS_HEADER_BUTTON_NEW_USER: 'Add Attender',
	// #endregion

	// #region Courses Misc (Dialog, etc.)
	TAB_USERS_COURSES: 'Attenders',
	VIEW_ITEM_NO_SKILL: 'No Skill specified',
	COURSES_BUTTON_REMOVE_ATTENDER: 'Remove Attender',
	DIALOG_ADD_ATTENDER_TITLE: 'Add Attender',
	DIALOG_ADD_COURSE_TITLE: 'Add Course',
	DIALOG_REMOVE_ATTENDER_TITLE: 'Are you sure?'
	// #endregion
};

export default locale;
